module.exports = __webpack_public_path__ + "img/step8.7b8902d3.png";